export const MOCK_DB_UPDATED_EVENT = 'mockDbUpdated';

export type MockDbUpdatedDetail = {
    collection: string;
};

/**
 * Maps each mock IndexedDB collection (see `DEFAULT_ID_FIELD_NAMES` in
 * `mock-utils/custom-db.mjs`) to the React Query key prefixes that read from
 * it, so a console-driven mock write can invalidate exactly what displays it.
 * `incidentReports` also invalidates `criticalIncident` because
 * `mock-utils/request-core.mjs`'s `referrals` post-processor stitches each
 * referral's `incidentReportStatus` from that collection. `credentials` has
 * no entry because it's fetched via GraphQL/Apollo, not React Query.
 */
export const COLLECTION_QUERY_KEYS: Record<string, unknown[][]> = {
    referrals: [['criticalIncident']],
    documentRequests: [['documentRequests']],
    incidentReports: [['incidentReports'], ['criticalIncident']],
    credentials: [],
};

export function getQueryKeysForCollection(collection: string): unknown[][] {
    return COLLECTION_QUERY_KEYS[collection] ?? [];
}

/**
 * Notifies any mounted `useMockDbSync` listeners that a mock IndexedDB
 * collection was written to via `window.TPH.insertMockRecord()` /
 * `updateMockIncidentReport()`, so they can refetch the affected React Query
 * queries. Dispatched as a `window` event (mirrors `useSessionFlag.ts`'s
 * `sessionStorageUpdated` event) rather than importing React Query directly,
 * since this module is shared with `browser.ts`, which intentionally avoids
 * a circular dependency with React-aware modules.
 */
export function notifyMockDbUpdated(collection: string) {
    window.dispatchEvent(new CustomEvent<MockDbUpdatedDetail>(MOCK_DB_UPDATED_EVENT, { detail: { collection } }));
}
